module.exports = __webpack_public_path__ + "img/master.ced58ce6.svg";